module.exports = __webpack_public_path__ + "static/media/tips_and_updates_FILL0_wght400_GRAD0_opsz48 (1).5ca4d53b.svg";